import React, { useState, useEffect } from 'react';

import { 
  ShoppingCartIcon, 

} from '@heroicons/react/24/outline';

import './Header.css';


const CartTag = ({openCart, getItemCount}: {openCart: () => void, getItemCount: () => number}) => {
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setHasAnimated(true);
    }, 300); // Small delay for better effect
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`user-actions ${hasAnimated ? 'animated' : ''}`}>
      <button 
        className="action-button cart-button"
        onClick={openCart}
      >
        <ShoppingCartIcon height={30} width={30}/>
        <span className="cart-count">{getItemCount()}</span>
      </button>
    </div>
  );
};
export default CartTag;
